<div class="counts" *ngIf="salesManagementCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Sales Management
        <span>{{ salesManagementCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'salesManagementCounts',
          'pendingApproval'
        ]"
      >
        <p class="count">Pending Approval</p>
        <span>{{ salesManagementCounts.pendingApproval }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'salesManagementCounts',
          'approvedDoNotSchedule'
        ]"
      >
        <p class="count">Approved Don't Schedule</p>
        <span>{{ salesManagementCounts.approvedDoNotSchedule }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'salesManagementCounts', 'cancelled']"
      >
        <p class="count">Cancelled</p>
        <span>{{ salesManagementCounts.cancelled }}</span>
      </div>
      <div *ngIf="allowCommissionReview"
        class="panel-item"
        [routerLink]="['counts/list', 'salesManagementCounts', 'commission']"
      >
        <p class="count">Commission Review</p>
      </div>
    </div>
  </mat-expansion-panel>
</div>
